/**
 * @module features/devices/api/useBulkImport
 * @description Hooks for CSV template download and bulk upload.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deviceKeys, downloadCsvTemplate, uploadBulkCsv } from "./devices-api";

export function useBulkImport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ deviceType, file }: { deviceType: string; file: File }) =>
      uploadBulkCsv(deviceType, file),
    onSuccess: () => qc.invalidateQueries({ queryKey: deviceKeys.all }),
  });
}

export function useDownloadCsvTemplate() {
  return useMutation({ mutationFn: (deviceType: string) => downloadCsvTemplate(deviceType) });
}
